import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalenderSchedule = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M15,3V5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7,3V5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M3,8H19"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M19,10V6a2,2,0,0,0-2-2H5A2,2,0,0,0,3,6V17a2,2,0,0,0,2,2h6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7,10.75A.25.25,0,1,0,7.25,11,.249.249,0,0,0,7,10.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7,14.75A.25.25,0,1,0,7.25,15,.249.249,0,0,0,7,14.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M10.75,11A.25.25,0,1,0,11,10.75a.249.249,0,0,0-.25.251"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M17.293,20.707l4.414-4.414a1,1,0,0,0,0-1.414l-1.586-1.586a1,1,0,0,0-1.414,0l-4.414,4.414a1,1,0,0,0-.293.707V21h2.586a1,1,0,0,0,.707-.293Z"
		})
	]
});
export default SvgCalenderSchedule;
